<script setup lang="ts" />

<template>
    <div class="color-footer">
        <div class="orange" />
        <div class="yellow" />
        <div class="green" />
        <div class="purple" />
    </div>
</template>
